/**
 * @generated SignedSource<<98a06f3e327acfab3599f483a1e87418>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type table_projectVersions$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly canEditVersions?: {
        readonly canPerform: boolean;
      } | null | undefined;
      readonly key: string;
      readonly versions: {
        readonly __id: string;
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly allIssues: {
              readonly totalCount: number | null | undefined;
            } | null | undefined;
            readonly description: string | null | undefined;
            readonly doneIssues: {
              readonly totalCount: number | null | undefined;
            } | null | undefined;
            readonly id: string;
            readonly overdue: boolean | null | undefined;
            readonly releaseDate: AGG$DateTime | null | undefined;
            readonly startDate: AGG$DateTime | null | undefined;
            readonly status: JiraVersionStatus | null | undefined;
            readonly " $fragmentSpreads": FragmentRefs<"actions_projectVersions_ActionsCell_jiraVersion" | "name_projectVersions_NameCell_jiraVersion" | "progressBar_projectVersions_VersionProgress">;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly totalCount: number;
      };
      readonly " $fragmentSpreads": FragmentRefs<"actions_projectVersions_ActionsCell_jiraProject" | "name_projectVersions_NameCell_jiraProject">;
    };
  };
  readonly " $fragmentType": "table_projectVersions";
};
export type table_projectVersions$key = {
  readonly " $data"?: table_projectVersions$data;
  readonly " $fragmentSpreads": FragmentRefs<"table_projectVersions">;
};

import projectVersion_PaginationQuery_graphql from './projectVersion_PaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "jira",
  "jiraProjectByKey",
  "versions"
],
v1 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v2 = [
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": [
        "UNRELEASED"
      ],
      "kind": "LocalArgument",
      "name": "filter"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isManageVersionsPermissionEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "searchString"
    },
    {
      "defaultValue": {
        "order": "DESC",
        "sortByField": "SEQUENCE"
      },
      "kind": "LocalArgument",
      "name": "sortBy"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": projectVersion_PaginationQuery_graphql
    }
  },
  "name": "table_projectVersions",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                {
                  "kind": "Variable",
                  "name": "cloudId",
                  "variableName": "cloudId"
                },
                {
                  "kind": "Variable",
                  "name": "key",
                  "variableName": "projectKey"
                }
              ],
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "jiraProjectByKey",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  "action": "THROW",
                  "path": "jira.jiraProjectByKey.key"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "name_projectVersions_NameCell_jiraProject"
                },
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "isManageVersionsPermissionEnabled",
                      "variableName": "isManageVersionsPermissionEnabled"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "actions_projectVersions_ActionsCell_jiraProject"
                },
                {
                  "condition": "isManageVersionsPermissionEnabled",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": "canEditVersions",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "type",
                          "value": "MANAGE_VERSIONS"
                        }
                      ],
                      "concreteType": "JiraProjectAction",
                      "kind": "LinkedField",
                      "name": "action",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "kind": "ScalarField",
                            "name": "canPerform"
                          },
                          "action": "THROW",
                          "path": "jira.jiraProjectByKey.canEditVersions.canPerform"
                        }
                      ],
                      "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                    }
                  ]
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "alias": "versions",
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "filter",
                        "variableName": "filter"
                      },
                      {
                        "kind": "Variable",
                        "name": "searchString",
                        "variableName": "searchString"
                      },
                      {
                        "kind": "Variable",
                        "name": "sortBy",
                        "variableName": "sortBy"
                      }
                    ],
                    "concreteType": "JiraVersionConnection",
                    "kind": "LinkedField",
                    "name": "__uiProject__versions_connection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": (v1/*: any*/),
                        "action": "THROW",
                        "path": "jira.jiraProjectByKey.versions.totalCount"
                      },
                      {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraVersion",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "id"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "status"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "description"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "startDate"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "releaseDate"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "overdue"
                              },
                              {
                                "alias": "allIssues",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": "ALL"
                                  }
                                ],
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "issues",
                                "plural": false,
                                "selections": (v2/*: any*/),
                                "storageKey": "issues(filter:\"ALL\")"
                              },
                              {
                                "alias": "doneIssues",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": "DONE"
                                  }
                                ],
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "issues",
                                "plural": false,
                                "selections": (v2/*: any*/),
                                "storageKey": "issues(filter:\"DONE\")"
                              },
                              {
                                "kind": "FragmentSpread",
                                "name": "progressBar_projectVersions_VersionProgress"
                              },
                              {
                                "kind": "FragmentSpread",
                                "name": "name_projectVersions_NameCell_jiraVersion"
                              },
                              {
                                "kind": "FragmentSpread",
                                "name": "actions_projectVersions_ActionsCell_jiraVersion"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "__typename"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          }
                        ]
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": {
                              "kind": "ScalarField",
                              "name": "__id"
                            },
                            "action": "THROW",
                            "path": "jira.jiraProjectByKey.versions.__id"
                          }
                        ]
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "jira.jiraProjectByKey.versions"
                }
              ]
            },
            "action": "THROW",
            "path": "jira.jiraProjectByKey"
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "cf9237bc92fce2676b1bfc7b6dbe5172";

export default node;
